const urls = {
  login: "/auth/login",
  dashboard: "/dashboard",
  produit: "/produit",
  statique: "/statique",
  user: "/user",
  commande: "/commande",
  appro: "/approvisionnement",
  deposit: "/deposit",
  rapport: "/rapport",
  mobileLogin: "/auth/login-mobile"
};

export default urls;
